import { productInformationStyles as styles } from "@dillon/Overrides/Widgets/ProductList/ProductListProductInformation";
import { mediaQueriesBP } from "@dillon/Utilities/variables";
import { css } from "styled-components";

styles.wishListFacetsContainer = {
    width: 12,
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 8px;

        ${mediaQueriesBP.minMD} {
            gap: 16px;
            margin: 10px 0;
        }
    `,
};
